(() => {
  if (window.vpPrivacyLinkInitialized) return;
  window.vpPrivacyLinkInitialized = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-vp-cookie-preferences]');
    if (!button) return;
    event.preventDefault();
    const status = button.parentElement.querySelector('[data-vp-cookie-status]');
    try {
      if (typeof window.privacyBanner?.showPreferences === 'function') {
        await window.privacyBanner.showPreferences();
      } else {
        const nativeButton = document.getElementById('shopify-pc__banner__btn-manage-prefs');
        if (!nativeButton) throw new Error('Native privacy banner unavailable');
        nativeButton.click();
      }
      if (status) status.textContent = '';
    } catch {
      if (status) status.textContent = status.dataset.unavailable;
    }
  });
})();
